import React from 'react';
import { arrayToSimpleObj } from '../../utils';
import BubbleCommon, {
  netSentimentSelectTips,
  sentimentSelectTips,
} from '../BubbleCommon';

export const gameStoreSelect = [
  { value: 'comment_time', text: 'Time' },
  { value: 'sort_isvalid', text: 'Validation' },
];

export const gameStoreResultSelect = [
  { value: 'comment_time', text: 'Time' },
  { value: 'relevance', text: 'Relevance' },
];

export const gameStoreSelectPubg = [
  { value: 'order_number', text: 'Most Valuable' },
  { value: 'sort_isvalid', text: 'Validation' },
  { value: 'comment_time', text: 'Time' },
];

export const socialMediaAndPlayFeedBackResultSelect = [
  { value: 'relevance', text: 'Relevance' }, // relevant 换成 relevance
  { value: 'comment_time', text: 'Time' },
  { value: 'sort_isvalid', text: 'Validation' }, 
  { value: 'engagement', text: 'Engagement' },
  { value: 'tweets_like', text: 'Like' },
  { value: 'tweets_unlike', text: 'Dislike' },
  { value: 'share', text: 'Share-2' },
  { value: 'tweets_reply', text: 'Comment' },
  { value: 'view', text: 'View' },
  { value: 'follower_number', text: 'Follower/Subscriber' },
];

export const socialSortSelectOptions = [
  { value: 'sort_isvalid', text: 'Validation' },
  { value: 'comment_time', text: 'Time' },
  { value: 'engagement', text: 'Engagement' },
  { value: 'tweets_like', text: 'Like' },
  { value: 'tweets_unlike', text: 'Dislike' },
  { value: 'share', text: 'Share-2' },
  { value: 'tweets_reply', text: 'Comment' },
  { value: 'view', text: 'View' },
  { value: 'follower_number', text: 'Follower/Subscriber' },
];

export const sortByOptions = [
  { value: 'engagement', text: 'Engagement' },
  { value: 'sort_isvalid', text: 'Validation' },
  { value: 'comment_time', text: 'Time' },
];

export const newsTimeSelectOptions = [
  { value: 'release_time', text: 'Time' },
  { value: 'relevance', text: 'Relevance' }, // relevant 换成 relevance
];

export const reviewSelectOptions = [
  {
    value: 'all',
    text: 'Posts & Comments',
  },
  { value: 'posts', text: 'Posts' },
];

export const singleLanguageSelectOptions = [
  { value: 'origin', text: 'Original' },
  { value: 'en', text: 'English' },
  { value: 'zh', text: 'Chinese' },
];

export const languageSelectOptions = [
  {
    value: 'origin',
    text: 'Original Language',
    nValue: 0,
    selectText: 'Original',
    tips: {
      en: 'For compound words, the feature does not take effect. After switching the source language of a compound word, it still displays in English.',
      zh: '针对合成词不生效。合成词切换源语种后，仍将显示英文。',
    },
  },
  { value: 'en', text: 'English', nValue: 1, selectText: 'English' },
  { value: 'zh', text: 'Chinese', nValue: 2, selectText: 'Chinese' },
];

export const languageSelectMap = arrayToSimpleObj(
  languageSelectOptions,
  'selectText',
);

export const languageNumValueMap: { [key: string]: number } = arrayToSimpleObj(
  languageSelectOptions,
  'nValue',
);

export const searchSelectOptions = (formatMessage: any) => {
  return [
    {
      value: 'fuzzy',
      text: (
        <div>
          <BubbleCommon
            tipsMap={{
              en: 'Enter partial text or letters to match the original comment, English translation, and Chinese translation.',
              zh: '键入部分文字或字母即可匹配评论原文、英译及中译内容。',
            }}
            showIcon={false}
          >
            {formatMessage({ id: 'Fuzzy-match' })}
          </BubbleCommon>
        </div>
      ),
      btnText: 'Fuzzy-match',
    },
    {
      value: 'exact',
      text: (
        <div>
          <BubbleCommon
            tipsMap={{
              zh: '使用键入文本去匹配评论的原文、英译和中译。支持分词搜索，但最多返回 Top 2000 相关的数据。',
              en: 'Type the text to match the original, English, and Chinese translations of the comments. Supports tokenized search, but returns a maximum of the top 2,000 relevant results.',
            }}
            showIcon={false}
          >
            {formatMessage({ id: 'Exact-match' })}
          </BubbleCommon>
        </div>
      ),
      btnText: 'Exact-match',
    },
    {
      value: 'extend',
      text: (
        <div>
          <BubbleCommon
            showIcon={false}
            tipsMap={{
              en: 'Use the original and multiple language translations text of the typed text to match the original, English and Chinese translations of the comments. Supports tokenized search, but returns a maximum of the top 2,000 relevant results.',
              zh: '使用键入文本的原文以及多个语种的翻译内容，去匹配评论的原文、英译和中译。支持分词搜索，但最多返回 Top 2000 相关的数据。',
            }}
          >
            {formatMessage({ id: 'Broad-match with multiple languages' })}
          </BubbleCommon>
        </div>
      ),
      btnText: 'Broad-match',
    },
  ];
};

// All
// Noun 名词
// Adj 形容词
// Verb 动词
export const partOfSpeechOptions = [
  { value: 'all', text: 'All' },
  { value: 'NOUN', text: 'Noun' },
  { value: 'ADJ', text: 'Adj' },
  { value: 'VERB', text: 'Verb' },
];

export const distanceOptions = [
  { value: 'all', text: 'All' },
  { value: '1', text: '1' },
  { value: '2', text: '2' },
  { value: '3', text: '3' },
];

export const sentimentOptions = (formatMessage: any) => {
  return [
    {
      value: 'Net Sentiment',
      text: (
        <div>
          <BubbleCommon tipsMap={netSentimentSelectTips} showIcon={false}>
            {formatMessage({ id: 'Net Sentiment' })}
          </BubbleCommon>
        </div>
      ),
      btnText: 'Net Sentiment',
    },
    {
      value: 'Sentiment',
      text: (
        <div>
          <BubbleCommon showIcon={false} tipsMap={sentimentSelectTips}>
            {formatMessage({ id: 'Sentiment' })}
          </BubbleCommon>
        </div>
      ),
      btnText: 'Sentiment',
    },
  ];
};
